export default __webpack_public_path__ + "1705cce0c31460ef823371d9e4fb6bbb.svg";